<template>
  <div class="ventrata-currency-conflict">
    <div class="ventrata-currency-conflict-header">
      <div class="ventrata-currency-conflict-header-title">
        {{ title }}
      </div>
    </div>

    <div class="ventrata-currency-conflict-body">
      <div class="ventrata-currency-conflict-body-content">
        {{ content }}
      </div>
    </div>

    <div class="ventrata-currency-conflict-footer">
      <div class="ventrata-currency-conflict-footer-buttons">
        <!-- <button class="ventrata-currency-conflict-footer-button secondary" @click="onBack">
          {{ backButtonText }}
        </button> -->
        <button class="ventrata-currency-conflict-footer-button primary" @click="onProceed">
          {{ proceedButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VentrataCurrencyConflict',
  components: {},
  props: {
    selectedAvailableTime: {
      type: Object,
      require: false
    }
  },
  data() {
    return {
      backButtonText: 'Back',
      proceedButtonText: 'Proceed',
      title: 'Warning',
      content: 'Cannot add item with different currency from original order.',
    }
  },
  methods: {
    onBack() {
      this.$emit('back')
    },
    onProceed() {
      this.$emit('proceed')
    }
  }
}
</script>
<style lang="scss" scoped>
.ventrata-currency-conflict {
  padding: 32px;
  border-radius: 12px;
  background-color: #fff;
  border: 1px solid #C8D1D8;

  gap: 16px;
  display: flex;
  flex-direction: column;

  .ventrata-currency-conflict-header-title {
    color: #443C47;
    font-weight: 500;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0px;
  }

  .ventrata-currency-conflict-body-content {
    color: #443C47;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0px;
  }

  .ventrata-currency-conflict-footer-buttons {
    display: flex;
    gap: 16px;
  }

  .ventrata-currency-conflict-footer-button {
    width: 100%;
    padding: 12px 16px;
    border-radius: 90px;
    border: 1px solid #1646A8;

    color: #443C47;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: center;
    cursor: pointer;

    &.primary {
      background-color: #1646A8;
      color: #fff;
    }

    &.secondary {
      background-color: #fff;
      color: #1646A8;
    }
  }
}
</style>
